import { ClientContact } from '@/entities/clientContact';
import { UpdateClientStatusDto } from '@/entities/clients';
import { Indicator } from '@/entities/indicator';
import { useClients } from '@/hook/useClients';
import { ClientService } from '@/services/ClientsService';
import React, { useState } from 'react';

interface ClientInterface{
    open: boolean,
    isEdit: boolean,
    deleteOpen:boolean,
    data2Edit: any
}

const ClientContext = React.createContext<any>({} as ClientInterface);

export const ClientProvider: React.FC<any> = ({ children }) => {

  const {updateClientStatus} = useClients();

  const [ open, setOpen ] = useState(false);
  const [ isEdit, setEdit ] = useState(false);
  const [ indexEdit, setIndexEdit] = useState<number | undefined>(undefined);
  const [ data2Edit, setData2Edit ] = useState<any>();
  const [ deleteOpen, setDeleteOpen ] = useState(false);
  const [ openContact, setOpenContact ] = useState(false);
  const [ isEditContact, setEditContact ] = useState(false);
  const [ deleteClient, setDeleteClient ] = useState(false);
  const [ deleteContact, setDeleteContact ] = useState(false);
  const [ alterStatus, setAlterStatus ] = useState(false);
  const [ contacts, setContacts ] = useState<ClientContact[] | []>();
  const [ clientId, setClientId ] = useState<number | undefined>();

  const onClientStatusUpdate = async (index:number, client:UpdateClientStatusDto) =>{
    updateClientStatus(index, client);
  };

  return(
    <ClientContext.Provider value={{clientId, setClientId, alterStatus, setAlterStatus, deleteContact, setDeleteContact, deleteClient, setDeleteClient, open, isEdit, setOpen, setEdit, indexEdit, setIndexEdit, data2Edit, setData2Edit, deleteOpen, setDeleteOpen, openContact, setOpenContact, isEditContact, setEditContact}}>{children}</ClientContext.Provider>
  );

};

export const useClientContext = () => React.useContext(ClientContext);
